var exports = {
  "p": "xfd349460--efc9ee--list",
};

module.exports = exports;
